import { render, staticRenderFns } from "./CreateBankAccountPage.vue?vue&type=template&id=37509e3c&scoped=true&"
import script from "./CreateBankAccountPage.vue?vue&type=script&lang=js&"
export * from "./CreateBankAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateBankAccountPage.vue?vue&type=style&index=0&id=37509e3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37509e3c",
  null
  
)

export default component.exports